import { useQuery } from "@tanstack/react-query"
import { capabilitiesQuery } from "../lib/capabilitiesQuery"

export function useCapabilitiesQuery(...args: Parameters<typeof capabilitiesQuery>) {
  return useQuery(capabilitiesQuery(...args))
}
